export const kindLabel = (k) => ({ agent: "Elite Rentals", owner: "Owner lead", fsbo: "FSBO", expired: "Expired / cancelled", rp: "Buyer's agent" }[k] || "Owner lead");
